import { useQuery } from 'react-query'
import { QUERY_KEYS } from '@/lib/cache-keys/queryKeys'
import { walletApi } from 'api/walletApi'
import { formatCurrency } from '@/utils/formatters'

export const useWalletBalance = (enabled: boolean) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [QUERY_KEYS.WALLET_BALANCE],
    queryFn: () => walletApi.getWalletBalance(),
    refetchOnWindowFocus: true,
    enabled,
  })

  const cash = (data?.cash_balance_pence ?? 0) / 100
  const siteCredit = (data?.bonus_balance_pence ?? 0) / 100

  const isUnavailable = enabled && isError && !data

  // Text for any balance figure, so every place shows the same thing: '…' while loading,
  // '—' if it couldn't be loaded, never a placeholder £0.00.
  const format = (amount: number) => {
    if (enabled && isLoading) return '…'
    if (isUnavailable) return '—'
    return formatCurrency(amount)
  }

  return {
    format,
    cash,
    siteCredit,
    total: cash + siteCredit,
    isLoading: enabled && isLoading,
    isUnavailable,
  }
}
